import React from "react";

export default function LoginFormTitle() {
  return <h3 className="log-in__title">Tizimga kirish</h3>;
}
